module.exports = __webpack_public_path__ + "img/BJT1.7f46f306.svg";